import React, { useMemo, useContext } from "react";
import { AuthContext } from "shared/context/auth-context";
import { useSearchParams } from "react-router-dom";
import { resolveTabIndexFromQuery } from "pages/shared/utility";
import { useTranslation } from "react-i18next";
import { PERMISSION_TYPES } from "@routebot/constants";
import { isInternationalTheme } from "config/ConfigUtils";

import TrackStudentVehicleList from "features/track-vehicle/TrackStudentVehicleList";
import TrackPersonelVehicleList from "features/track-vehicle/TrackPersonelVehicleList";
import TrackVehicleReports from "features/track-vehicle/reports/TrackVehicleReports";
// See: backend/docs/arvento-telemetry.md §11 — Telemetri sekmesi koşullu eklenir.
import Telemetry from "features/telemetry/Telemetry";
// See: backend/docs/arvento-telemetry.md §20 — Uyarı Merkezi, Telemetri'nin hemen altında sekme.
import AlertCenter from "features/telemetry/alerts/AlertCenter";

import Tabs from "components/ui/tabs/Tabs";

const UsersPage = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const trackVehiclePageTabs = useMemo(() => {
    let allTabs = [];

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS]) {
      allTabs.push({
        id: "personelServices",
        label: t("personelServices"),
        content: <TrackPersonelVehicleList />,
      });
    }

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS]) {
      allTabs.push({
        id: "vehicleRoutes",
        label: t("vehicleRoutes"),
        content: <TrackStudentVehicleList />,
      });
    }

    if (!isInternationalTheme()) {
      allTabs.push({
        id: "reports",
        label: t("reports"),
        content: <TrackVehicleReports />,
      });
    }

    const hasTelemetryPermission = Boolean(auth.permissions?.[PERMISSION_TYPES.ACCESS_TO_TELEMETRY]);
    const arventoTelemetry = hasTelemetryPermission && Boolean(auth.company?.arventoConfig?.enabled);
    const geotabTelemetry = hasTelemetryPermission && Boolean(auth.company?.geotabConfig?.enabled);
    if (arventoTelemetry || geotabTelemetry) {
      allTabs.push({
        id: "telemetry",
        label: t("telemetry"),
        content: <Telemetry />,
      });
    }
    // Uyarı Merkezi Arvento olaylarına bağlı. Geotab demosu bu sekmeyi açmaz.
    if (arventoTelemetry) {
      allTabs.push({
        id: "telemetryAlerts",
        label: t("telemetryAlertCenter"),
        content: <AlertCenter />,
      });
    }

    return allTabs;
  }, [t, auth.permissions, auth.company?.arventoConfig?.enabled, auth.company?.geotabConfig?.enabled]);

  // if (trackVehiclePageTabs.length === 1) {
  //   if (trackVehiclePageTabs[0].label === t("personelServices")) {
  //     return <TrackPersonelVehicleList />;
  //   } else {
  //     return <TrackStudentVehicleList />;
  //   }
  // }

  const tabParam = searchParams.get("tab");
  const initialTabIndex = resolveTabIndexFromQuery(tabParam, trackVehiclePageTabs);

  return (
    <Tabs tabs={trackVehiclePageTabs} isVertical={true} id="track-vehicles-page" initialTabIndex={initialTabIndex} />
  );
};

export default UsersPage;
